module.exports = __webpack_public_path__ + "static/media/phone_1.21b34d7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/introduction/assets/phone_1.png
// module id = 210
// module chunks = 0